import { getMappedLanguage } from 'i18n/helpers';

interface EmojiPickerI18nModule {
  default: Record<string, unknown>;
}

const EMOJI_PICKER_I18N_LOADERS: Record<
  string,
  () => Promise<EmojiPickerI18nModule>
> = {
  en: () => import('emoji-picker-element/i18n/en'),
  ar: () => import('emoji-picker-element/i18n/ar'),
  de: () => import('emoji-picker-element/i18n/de'),
  es: () => import('emoji-picker-element/i18n/es'),
  fr: () => import('emoji-picker-element/i18n/fr'),
  nl: () => import('emoji-picker-element/i18n/nl'),
  tr: () => import('emoji-picker-element/i18n/tr'),
  pt_br: () => import('emoji-picker-element/i18n/pt_BR'),
  pt_pt: () => import('emoji-picker-element/i18n/pt_PT'),
  ms_my: () => import('emoji-picker-element/i18n/ms_MY'),
};

export const getEmojiPickerLocaleKey = (): string => {
  const mappedLanguage = getMappedLanguage();
  if (!mappedLanguage) {
    return 'en';
  }

  const normalized = mappedLanguage.toLowerCase();

  if (EMOJI_PICKER_I18N_LOADERS[normalized]) {
    return normalized;
  }

  return normalized.split('_')[0];
};

export const loadEmojiPickerI18n = (
  localeKey: string,
): Promise<EmojiPickerI18nModule> => {
  const loader =
    EMOJI_PICKER_I18N_LOADERS[localeKey] ||
    EMOJI_PICKER_I18N_LOADERS[localeKey.split('_')[0]] ||
    EMOJI_PICKER_I18N_LOADERS.en;

  return loader();
};
